import React from 'react';
import Icon from '../../../components/AppIcon';

const EventTimeline = ({ events }) => {
  const getSeverityColor = (severity) => {
    const colors = {
      critical: 'var(--color-error)',
      error: 'var(--color-error)',
      warning: 'var(--color-warning)',
      info: 'var(--color-info)'
    };
    return colors?.[severity] || 'var(--color-muted)';
  };

  const getEventTypeIcon = (eventType) => {
    const icons = {
      failed_login: 'Lock',
      suspicious_activity: 'AlertTriangle',
      unauthorized_access: 'ShieldAlert',
      data_breach_attempt: 'Database',
      privilege_escalation: 'TrendingUp',
      account_lockout: 'UserX',
      password_reset: 'Key',
      session_hijacking: 'Wifi'
    };
    return icons?.[eventType] || 'AlertCircle';
  };

  const groupEventsByDate = (events) => {
    const grouped = {};
    events?.forEach(event => {
      const date = new Date(event?.created_at)?.toLocaleDateString();
      if (!grouped?.[date]) grouped[date] = [];
      grouped?.[date]?.push(event);
    });
    return grouped;
  };

  const groupedEvents = groupEventsByDate(events);

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">
          Event Timeline
        </h3>
        <span className="text-sm text-muted-foreground">
          {events?.length || 0} events
        </span>
      </div>
      <div className="space-y-8">
        {Object.entries(groupedEvents)?.map(([date, dateEvents]) => (
          <div key={date}>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px flex-1 bg-border" />
              <span className="text-sm font-medium text-muted-foreground">{date}</span>
              <div className="h-px flex-1 bg-border" />
            </div>

            <div className="space-y-4">
              {dateEvents?.map((event, index) => (
                <div key={event?.id} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: `${getSeverityColor(event?.severity)}15` }}
                    >
                      <Icon
                        name={getEventTypeIcon(event?.event_type)}
                        size={18}
                        color={getSeverityColor(event?.severity)}
                      />
                    </div>
                    {index < dateEvents?.length - 1 && (
                      <div className="w-0.5 h-full bg-border mt-2" />
                    )}
                  </div>

                  <div className="flex-1 pb-6">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="text-sm font-medium text-foreground">
                        {event?.event_type?.replace(/_/g, ' ')?.toUpperCase()}
                      </h4>
                      <span
                        className="px-2 py-0.5 rounded text-xs font-medium"
                        style={{
                          backgroundColor: `${getSeverityColor(event?.severity)}15`,
                          color: getSeverityColor(event?.severity)
                        }}
                      >
                        {event?.severity}
                      </span>
                    </div>
                    <p className="text-sm text-muted-foreground mb-2">{event?.description}</p>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" size={12} />
                        {new Date(event?.created_at)?.toLocaleTimeString()}
                      </span>
                      <span className="flex items-center gap-1">
                        <Icon name="User" size={12} />
                        {event?.user?.full_name || 'Unknown'}
                      </span>
                      <span className="flex items-center gap-1">
                        <Icon name="MapPin" size={12} />
                        {event?.ip_address || 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {events?.length === 0 && (
          <div className="text-center py-12">
            <Icon name="Clock" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No events to display</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventTimeline;